import type { ReactNode } from 'react'

export const Badge = ({
  children,
  variant = 'info',
}: {
  children: ReactNode
  variant?: 'primary' | 'secondary' | 'info-dark' | 'info' | 'warning' | 'danger' | 'success'
}) => {
  const findColor = () => {
    switch (variant) {
      case 'primary':
        return 'ap:bg-primary ap:text-content-inverse'
      case 'secondary':
        return 'ap:bg-surface-dark-accent ap:text-content-secondary'
      case 'info-dark':
        return 'ap:bg-surface-info-dark ap:text-content-inverse'
      case 'info':
        return 'ap:bg-surface-background ap:border ap:border-stroke-primary ap:text-content-primary'
      case 'warning':
        return 'ap:bg-surface-warning ap:text-content-warning'
      case 'danger':
        return 'ap:bg-surface-danger ap:text-content-danger'
      case 'success':
        return 'ap:bg-surface-success-light ap:text-content-success'
      default:
        return 'ap:bg-primary ap:text-content-inverse'
    }
  }
  const color = findColor()

  return (
    <div
      className={`${color} ap:flex ap:items-center ap:justify-center ap:text-xs ap:py-xs ap:px-lg ap:rounded-full ap:w-fit ap:font-semibold ap:uppercase`}
    >
      {children}
    </div>
  )
}
